const baseballCaps =  {
  state: {
    models: [
      {
        type: 'baseballCaps', // тип изделия
        model: 'bejsbolka-poluvelyur', // УНИКАЛЬНОЕ, модель
        title: 'Бейсболка полувелюр', // заголовок
        description: `<p>Недорогая модель бейсболок выполнена из 100% хб ткани полувелюр. Идеальный вариант для промо акций с ограниченным бюджетом. Большой выбор расцветок и яркие сочные цвета. Пятиклинка с металлической застежкой.</p>
        <p><strong>Модель</strong>&nbsp;Пять клиньев без лобового шва, металлическая застежка и люверсы.</p>
        <p><strong>Состав:</strong>&nbsp;Хлопок – 100%, плотность 220 г/м²</p>
        <p><strong>Страна производства</strong> Китай</p>
        <p><strong>Коллекция</strong> Весна-лето 2018</p>
        <p><strong>Сезон</strong> Демисезон</p>
        <p><strong>Пол</strong> Унисекс</p>
        <p><strong>Название</strong> Бейсболка мужская Полувелюр</p>
        <p><strong>Размер</strong> универсальный</p>`,
        gender: 'unisex', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'burgundy', 'dark-green', 'green', 'red', 'azure', 'orange', 'sand',
          'gray', 'blue', 'dark-blue', 'white', 'yellow'], // доступные цвета
        defaultColor: 'orange',
        image: 'https://pr-tex.ru/wp-content/uploads/orange-1.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/black-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/black-2-100x100.jpg',
          },
          {
            color: 'burgundy',
            image: 'https://pr-tex.ru/wp-content/uploads/bordo.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/bordo-100x100.jpg',
          },
          {
            color: 'dark-green',
            image: 'https://pr-tex.ru/wp-content/uploads/temno-zeleniy_side-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/temno-zeleniy_side-1-100x100.jpg',
          },
          {
            color: 'green',
            image: 'https://pr-tex.ru/wp-content/uploads/zeleniy-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/zeleniy-1-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/krasniy-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/krasniy-1-100x100.jpg',
          },
          {
            color: 'azure',
            image: 'https://pr-tex.ru/wp-content/uploads/goluboy-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/goluboy-1-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/orange-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/orange-1-100x100.jpg',
          },
          {
            color: 'sand',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/04/%D0%B1%D0%B5%D0%B6%D0%B5%D0%B2%D1%8B%D0%B9.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/04/%D0%B1%D0%B5%D0%B6%D0%B5%D0%B2%D1%8B%D0%B9-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/seriy-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/seriy-2-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/siniy-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/siniy-2-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/temno-siniy-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/temno-siniy-2-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/white-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/white-2-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/yellow-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/yellow-2-100x100.jpg',
          },
        ],
        sizes: [], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 0, to: 10, price: 220 },
          {from: 11, to: 20, price: 170 },
          {from: 21, to: 50, price: 140 },
          {from: 51, to: 100, price: 110 },
          {from: 101, to: 250, price: 110 },
          {from: 251, to: 500, price: 105 },
          {from: 501, to: 1000, price: 99 },
          {from: 1001, to: 3000, price: 96 },
          {from: 3001, to: 5000, price: 94 },
          {from: 5001, to: 10000, price: 92 },
          {from: 10001, to: 99999, price: 90 },
        ]
      },
      {
        type: 'baseballCaps', // тип изделия
        model: 'bejsbolka-vielyur', // УНИКАЛЬНОЕ, модель
        title: 'Бейсболка Велюр', // заголовок
        description: `<p>Бейсболка выполнена из плотного хлопка с начесом.&nbsp;Жесткий козырек “сэндвич”, обшивные люверсы, металлическая застежка, регулируемый объем. Пять клиньев без лобового шва</p>
        <p><strong>Состав:</strong> Хлопок – 100%, плотность 300-350 г/м²</p>
        <p><strong>Страна производства</strong>&nbsp;Китай</p>
        <p><strong>Сезон</strong> Демисезон</p>
        <p><strong>Пол</strong> Унисекс</p>
        <p><strong>Возраст</strong> Взрослая</p>
        <p><strong>Размер</strong> универсальный</p>`,
        gender: 'unisex', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'red', 'gray', 'blue', 'dark-blue', 'white', 'yellow'], // доступные цвета
        defaultColor: 'dark-blue',
        image: 'https://pr-tex.ru/wp-content/uploads/temno-siniy-1.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/black-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/black-1-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/krasniyside.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/krasniyside-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/seriy-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/seriy-1-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/siniy-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/siniy-1-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/temno-siniy-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/temno-siniy-1-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/white-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/white-2-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/yellow_side-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/yellow_side-1-100x100.jpg',
          },
        ],
        sizes: [], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 0, to: 10, price: 250 },
          {from: 11, to: 20, price: 220 },
          {from: 21, to: 50, price: 180 },
          {from: 51, to: 100, price: 160 },
          {from: 101, to: 250, price: 150 },
          {from: 251, to: 500, price: 135 },
          {from: 501, to: 1000, price: 130 },
          {from: 1001, to: 3000, price: 128 },
          {from: 3001, to: 5000, price: 125 },
          {from: 5001, to: 10000, price: 121 },
          {from: 10001, to: 99999, price: 119 },
        ]
      },
      {
        type: 'baseballCaps', // тип изделия
        model: 'cap-na-lipuchke', // УНИКАЛЬНОЕ, модель
        title: 'Бейсболка на липучке', // заголовок
        description: `<p>Недорогая промо модель бейсболки для массовых мероприятий. Усиленный козырек, застежка на липучке.<br>
        <strong>Материал</strong> 100% хлопок, плотность 180&nbsp;г/м²<br>
        <strong>Страна производства</strong>&nbsp;Китай<br>
        <strong>Коллекция</strong> Весна-лето 2018<br>
        <strong>Сезон</strong> Демисезон<br>
        <strong>Пол</strong> Унисекс<br>
        <strong>Возраст</strong> Взрослая<br>
        <strong>Размер</strong> универсальный</p>`,
        gender: 'unisex', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'green', 'red', 'azure', 'orange', 'gray', 'blue', 'dark-blue',
          'white', 'yellow'], // доступные цвета
        defaultColor: 'orange',
        image: 'https://pr-tex.ru/wp-content/uploads/orange_side.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/black_side-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/black_side-1-100x100.jpg',
          },
          {
            color: 'green',
            image: 'https://pr-tex.ru/wp-content/uploads/zeleniy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/zeleniy-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/krasniy-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/krasniy-1-100x100.jpg',
          },
          {
            color: 'azure',
            image: 'https://pr-tex.ru/wp-content/uploads/goluboy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/goluboy-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/orange_side.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/orange_side-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/seriy_side-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/seriy_side-1-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/siniy_side.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/siniy_side-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/temno-siniy-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/temno-siniy-2-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/white_side-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/white_side-1-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/yellow-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/yellow-2-100x100.jpg',
          },
        ],
        sizes: [], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 0, to: 10, price: 180 },
          {from: 11, to: 20, price: 170 },
          {from: 21, to: 50, price: 150 },
          {from: 51, to: 100, price: 130 },
          {from: 101, to: 250, price: 115 },
          {from: 251, to: 500, price: 105 },
          {from: 501, to: 1000, price: 95 },
          {from: 1001, to: 3000, price: 89 },
          {from: 3001, to: 5000, price: 85 },
          {from: 5001, to: 10000, price: 83 },
          {from: 10001, to: 99999, price: 79 },
        ]
      },
      {
        type: 'baseballCaps', // тип изделия
        model: 'kozyrek', // УНИКАЛЬНОЕ, модель
        title: 'Козырек', // заголовок
        description: `<p>Козырек, регулируемая застежка на липучке<br>
        <strong>Материал</strong> 100% хлопок, плотность 180&nbsp;г/м²<br>
        <strong>Страна производства</strong> Россия<br>
        <strong>Пол</strong> Унисекс<br>
        <strong>Возраст</strong> Взрослая<br>
        <strong>Размер</strong> универсальный</p>`,
        gender: 'unisex', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'green', 'red', 'orange', 'blue', 'white'], // доступные цвета
        defaultColor: 'green',
        image: 'https://pr-tex.ru/wp-content/uploads/2019/03/kozirek_green.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/03/kozirek_black.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/03/kozirek_black-100x100.jpg',
          },
          {
            color: 'green',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/03/kozirek_green.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/03/kozirek_green-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/03/kozirek_red.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/03/kozirek_red-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/03/kozirek_orange.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/03/kozirek_orange-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/03/kozirek_siniy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/03/kozirek_siniy-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/03/kozirek_white.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/03/kozirek_white-100x100.jpg',
          },
        ],
        sizes: [], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 0, to: 20, price: 180 },
          {from: 21, to: 50, price: 150 },
          {from: 51, to: 100, price: 130 },
          {from: 101, to: 250, price: 115 },
          {from: 251, to: 500, price: 102 },
          {from: 501, to: 1000, price: 95 },
          {from: 1001, to: 3000, price: 87 },
          {from: 3001, to: 5000, price: 82 },
          {from: 5001, to: 10000, price: 80 },
          {from: 10001, to: 100000, price: 78 },
        ]
      },
    ]
  }
}

export default baseballCaps